<template>
  <div>
    <div class="div">
      <h2>Trailers</h2>
      <div id="trailers" class="carousel">
        <div class="movie carousel__container">
          <transition-group name="list" tag="p">
            <div
              class="carousel-item movie--item divs"
              v-for="(t, i) in showDetail.trailers"
              :key="i"
            >
              <iframe
                class="video"
                :src="t"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </transition-group>
        </div>
      </div>
      <button class="icon-carousel icon-prev" @click="prev">
        <font-awesome-icon icon="chevron-left" />
      </button>
      <button class="icon-carousel icon-next" @click="next">
        <font-awesome-icon icon="chevron-right" />
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: mapState(["showDetail"]),
  data() {
    return {};
  },
  methods: {
    prev: function() {
      let a = document.getElementById("trailers").scrollLeft;
      a -= 600;
      document
        .getElementById("trailers")
        .scroll({ left: a, behavior: "smooth" });
    },
    next: function() {
      let a = document.getElementById("trailers").scrollLeft;
      a += 600;
      document
        .getElementById("trailers")
        .scroll({ left: a, behavior: "smooth" });
    }
  }
};
</script>

<style scoped>
.list-item {
  display: inline-block;
  margin-right: 10px;
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}

.div {
  margin-top: 10px;
  position: relative;
}
h2 {
  font-weight: 400;
  border-bottom: 1px solid #738092;
}
.movie {
  margin-top: 5px;
}

.movie--item {
  margin-top: 15px;
  width: 390px;
  height: 224px;
  margin: 0 auto;
}
.video {
  width: 390px;
  height: 224px;
}

/* CAROUSEL */
.carousel {
  overflow: scroll;
  width: 100%;
  position: relative;
}

.carousel__container {
  transition: 450ms -webkit-transform;
  transition: 450ms transform;
  transition: 450ms transform, 450ms -webkit-transform;
  font-size: 0;
  white-space: nowrap;
  padding-bottom: 10px;
  margin-top: 15px;
}

.carousel-item {
  overflow: hidden;
  position: relative;
  display: inline-block;
  margin-right: 10px;
  font-size: 20px;
  cursor: pointer;
  transition: 450ms all;
  -webkit-transform-origin: center left;
  transform-origin: center left;
}

.carousel-item:hover ~ .carousel-item {
  -webkit-transform: translate3d(10px, 0, 0);
  transform: translate3d(10px, 0, 0);
}

.carousel-item__img {
  width: 95px;
  -o-object-fit: cover;
  object-fit: cover;
}

::-webkit-scrollbar {
  display: none;
}

.icon-carousel {
  background: rgba(0, 0, 0, 0);
  color: rgba(0, 0, 0, 0);
  border: 0px solid #9e9e9e;
  padding: 5px;
  cursor: pointer;
  position: absolute;
  z-index: 1000;
  bottom: 10px;
  height: 224px;
  width: 40px;
}
.icon-carousel:hover {
  background: rgba(0, 0, 0, 0.9);
  color: white;
}

.icon-prev {
  left: 0px;
}

.icon-next {
  right: 0px;
}
@media (min-width: 1264px) and (max-width: 1400px) {
  .video,
  .movie--item {
    width: 320px;
    height: 184px;
  }
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .video,
  .movie--item {
    width: 500px;
    height: 288px;
  }
}
@media (min-width: 960px) and (max-width: 1020px) {
  .video,
  .movie--item {
    width: 320px;
    height: 184px;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .video,
  .movie--item {
    width: 400px;
    height: 230px;
  }
}

@media (max-width: 600px) {
  .video,
  .movie--item {
    width: 314px;
    height: 181px;
    /* width: 320px;
    height: 184px; */
  }
}
</style>
